<template>
  <div class="bg-white">
    <CommHeader />
    <CommSwipe :dataList="swipeDataList" />
    <div class="container">
      <div class="common-margin-top common-padding-top text-center common-letter-spacing">
        <div class="common-margin-top-1 font-25">快付支付</div>
        <div class="common-margin-top-1-5 font-25">实战案例解析</div>
      </div>
      <div class="common-margin-top row">
        <div class="col col-12 col-md-4 col-lg-4 text-center">
          <div class="bg-blue-2 common-margin-1 common-padding-bottom">
            <div class="text-center common-padding-top">
              <img class="col-2-5" :src="require('images/product/circle-star.png')"/>
            </div>
            <div class="common-margin-top-1">
              <div class="font-16 common-line-height-2-5 common-letter-spacing">某新零售平台</div>
              <p class="common-margin-top-1 font-12 common-line-height-2 common-letter-spacing-1">
                赋能线下门店，重构消费连接<br />
                新零售解决方案：让门店经营更智慧，<br />
                驱动品牌智能发展。
              </p>
            </div>
            <div class="common-padding">
              <router-link tag="span" class="cursor-pointer common-padding-left common-padding-right common-padding-top-1 common-padding-bottom-1 common-letter-spacing-1 bg-purple radius-5 font-10 color-white"
                           :to="{path:'/product/xls'}">查看更多
              </router-link>
            </div>
          </div>
        </div>
        <div class="col col-12 col-md-4 col-lg-4 text-center">
          <div class="bg-blue-2 common-margin-1 common-padding-bottom">
            <div class="text-center common-padding-top">
              <img class="col-2-5" :src="require('images/product/circle-star.png')"/>
            </div>
            <div class="common-margin-top-1">
              <div class="font-16 common-line-height-2-5 common-letter-spacing">某高铁运营平台</div>
              <p class="font-12 common-line-height-2 common-letter-spacing-1 common-margin-top-1">
                赋能线下门店，重构消费连接<br />新零售解决方案：让门店经营更智慧，驱动<br />品牌智能发展。
              </p>
            </div>
            <div class="common-padding">
              <router-link tag="span" class="cursor-pointer common-padding-left common-padding-right common-padding-top-1 common-padding-bottom-1 common-letter-spacing-1 bg-purple radius-5 font-10 color-white"
                           :to="{path:'/product/gt'}">查看更多
              </router-link>
            </div>
          </div>
        </div>
        <div class="col col-12 col-md-4 col-lg-4 text-center">
          <div class="bg-blue-2 common-margin-1 common-padding-bottom">
            <div class="text-center common-padding-top">
              <img class="col-2-5" :src="require('images/product/circle-star.png')"/>
            </div>
            <div class="common-margin-top-1">
              <div class="font-16 common-line-height-2-5 common-letter-spacing">某加盟连锁店</div>
              <p class="font-12 common-line-height-2 common-letter-spacing-1 common-margin-top-1">
                返利+分销火爆的返利系统，让返利事业<br />可持续发展，让消费者成为财富，全民<br />参与、全民返利。
              </p>
            </div>
            <div class="common-padding">
              <router-link tag="span" class="cursor-pointer common-padding-left common-padding-right common-padding-top-1 common-padding-bottom-1 common-letter-spacing-1 bg-purple radius-5 font-10 color-white"
                           :to="{path:'/product/jmls'}">查看更多
              </router-link>
            </div>
          </div>
        </div>
        <div class="col col-12 col-md-4 col-lg-4 text-center">
          <div class="bg-blue-2 common-margin-1 common-padding-bottom">
            <div class="text-center common-padding-top">
              <img class="col-2-5" :src="require('images/product/circle-star.png')"/>
            </div>
            <div class="common-margin-top-1">
              <div class="font-16 common-line-height-2-5 common-letter-spacing">某社交电商</div>
              <p class="font-12 common-line-height-2 common-letter-spacing-1 common-margin-top-1">
                不同电商解决方案有不用的功能，适用<br />于不同的业务场景，拉近商家与客户之<br />间的距离，将“流量”变“销量”。
              </p>
            </div>
            <div class="common-padding">
              <router-link tag="span" class="cursor-pointer common-padding-left common-padding-right common-padding-top-1 common-padding-bottom-1 common-letter-spacing-1 bg-purple radius-5 font-10 color-white"
                           :to="{path:'/product/sjds'}">查看更多
              </router-link>
            </div>
          </div>
        </div>
        <div class="col col-12 col-md-4 col-lg-4 text-center">
          <div class="bg-blue-2 common-margin-1 common-padding-bottom">
            <div class="text-center common-padding-top">
              <img class="col-2-5" :src="require('images/product/circle-star.png')"/>
            </div>
            <div class="common-margin-top-1">
              <div class="font-16 common-line-height-2-5 common-letter-spacing">某返利APP</div>
              <p class="font-12 common-line-height-2 common-letter-spacing-1 common-margin-top-1">
                返利+分销火爆的返利系统，让返利事业<br />可持续发展，让消费者成为财富，全民<br />参与、全民返利。
              </p>
            </div>
            <div class="common-padding">
              <router-link tag="span" class="cursor-pointer common-padding-left common-padding-right common-padding-top-1 common-padding-bottom-1 common-letter-spacing-1 bg-purple radius-5 font-10 color-white"
                           :to="{path:'/product/fl'}">查看更多
              </router-link>
            </div>
          </div>
        </div>
        <div class="col col-12 col-md-4 col-lg-4 text-center">
          <div class="bg-blue-2 common-margin-1 common-padding-bottom">
            <div class="text-center common-padding-top">
              <img class="col-2-5" :src="require('images/product/circle-star.png')" />
            </div>
            <div class="common-margin-top-1">
              <div class="font-16 common-line-height-2-5 common-letter-spacing">某创意商城</div>
              <p class="font-12 common-line-height-2 common-letter-spacing-1 common-margin-top-1">
                返利+分销火爆的返利系统，让返利事业<br />可持续发展，让消费者成为财富，全民<br />参与、全民返利。
              </p>
            </div>
            <div class="common-padding">
              <router-link tag="span" class="cursor-pointer common-padding-left common-padding-right common-padding-top-1 common-padding-bottom-1 common-letter-spacing-1 bg-purple radius-5 font-10 color-white"
                           :to="{path:'/product/cysc'}">查看更多
              </router-link>
            </div>
          </div>
        </div>
        <CommSolution />
      </div>
    </div>
    <CommBrand />
    <CommFooter />
  </div>
</template>

<script>
import CommHeader from '@/components/CommHeader'
import CommSwipe from '@/components/CommSwipe'
import CommBrand from '@/components/CommBrand'
import CommFooter from '@/components/CommFooter'
import CommSolution from '@/components/CommSolution'
export default {
  name: 'home',
  components: {
    CommHeader,
    CommSwipe,
    CommBrand,
    CommSolution,
    CommFooter
  },
  data () {
    return {
      swipeDataList: [{img: require('images/home/sw-img1.jpg'),
        caption: '支付+生态',
        url: '#',
        describe: '扫码，APP支付，公众号支付,刷卡全都有。带完整的新零售生态系统，刷脸收款、扫码收款、打折、全返、返券、返矿、返......  您能想到的我们都有'
      }]
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/product/Product.vue